import * as React from 'react';
import { Button, UIHeading3, UIText2 } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const NotAvailableScreen = _ref => {
  let {
    onHouseFilterReset
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: style['image'],
      children: /*#__PURE__*/_jsx("div", {
        className: style['logo']
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: style['description'],
      children: [/*#__PURE__*/_jsx(UIHeading3, {
        textAlign: "center",
        children: "\u0412 \u044D\u0442\u043E\u043C \u043A\u043E\u0440\u043F\u0443\u0441\u0435 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043E\u0442\xA0\u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430 \u043D\u0435\u0442"
      }), /*#__PURE__*/_jsx(UIText2, {
        textAlign: "center",
        children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u043A\u043E\u0440\u043F\u0443\u0441"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style['controls'],
      children: /*#__PURE__*/_jsx(Button, {
        theme: "fill_secondary",
        size: "XS",
        onClick: onHouseFilterReset,
        children: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u043A\u043E\u0440\u043F\u0443\u0441\u0430"
      })
    })]
  });
};